import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractsCardItemComponent } from './contracts-card-item/contracts-card-item.component';
import { SharedModule } from '@shared/shared.module';
import { MatCoreModule } from '@shared/material/mat-core.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { ContractsRoutingModule } from './contracts-routing.module';
import { ContractsComponent } from './contracts.component';
import { ContractsTextComponent } from './contracts-text/contracts-text.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ViewRequestComponent } from './view-request/view-request.component';
import { ViewResponseComponent } from './view-response/view-response.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatInputModule } from '@angular/material/input';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ListRevisionContractsComponent } from './list-revision-contracts/list-revision-contracts.component';
import { NgxEditorModule } from 'ngx-editor';
import {MatExpansionModule} from '@angular/material/expansion';


@NgModule({
  declarations: [
    ContractsCardItemComponent,
    ContractsComponent,
    ContractsTextComponent,
    ViewRequestComponent,
    ViewResponseComponent,
    ListRevisionContractsComponent
  ],
  imports: [
    CommonModule,
    CdkAccordionModule,
    SharedModule,
    MatCoreModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    ContractsRoutingModule,
    TextFieldModule,
    HttpClientModule,
    AngularEditorModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEditorModule,
    MatExpansionModule
  ],
})
export class ContractsModule { }
